import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { ColorPicker } from './ColorPicker'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
    title:{
      backgroundColor:'#fff'
    },
    close: {
      cursor: 'pointer',
    }
}));

const style = {
  border: '1px dashed gray',
  backgroundColor: 'white',
  padding: '0.3rem 0.3rem',
  marginRight: '1.5rem',
  marginBottom: '0.5rem',
  cursor: 'move',
  minWidth: 200,  
  color:'rgba(0,0,0,.8)',
  textAlign: 'left',
  display: 'flex',
  justifyContent: 'space-between',  
  alignItems: 'center',
}

export const FieldSelected = (props) => {

  const {name} = props;
  const classes = useStyles();

  const [bckGrnColor, setBckGrnColor] = React.useState('#fff')

  const handlerColor = (item, a,b,c) => {    
    setBckGrnColor(item.hex)    
    props.eventOnColorPicker(item, a,b,c)
  }

  return (
    <div style={{ ...style}}>       
       <div><CloseIcon className={classes.close} onClick={() => props.eventoOnDelete(name, props.item, props.identify)} /></div>
       <div className={classes.title} >{name}</div>
       <div className={classes.title} >
         <ColorPicker eventOnChange={(e) => handlerColor(e, name, props.item, props.identify)} />
       </div>
       <div style={{backgroundColor:bckGrnColor, width:10, height:20}} ></div>
    </div>
  )
}
